import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {AlmacenService} from "../../services/api/almacen.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {
  DialogInventarioAventuraComponent
} from "../inventario/dialog-inventario-aventura/dialog-inventario-aventura.component";
import {DialogIngresoEquipoComponent} from "./dialog-ingreso-equipo/dialog-ingreso-equipo.component";
import { AventuraService } from 'src/app/services/api/aventura.service';

@Component({
  selector: 'app-ingreso-equipos',
  templateUrl: './ingreso-equipos.component.html',
  styleUrls: ['./ingreso-equipos.component.css']
})
export class IngresoEquiposComponent implements OnInit {

  loading:boolean=true;

  dataSource:any;

  articulos:any;

  displayedColumns: string[] = [
    'codigo',
    'nombre',
    'categoria',
    'marca',
    'modelo',
    'talla',
    'fileAsignado',
    // 'observacion',
    // 'valoracion',
    //'estado',
    'modificar'

  ];

  equipo:any

  selectMarca: string | null = null;
  selectModelo: string | null = null;
  selectTalla: string | null = null;
  selectCategoria: string | null = null;

  arrayMarcas: any = [];
  arrayModelos: any = [];
  arrayTallas: any = [];
  arrayCategorias: any = [];

  // @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private almacenService: AventuraService,public dialog: MatDialog,) { }

  ngOnInit(): void {
    this.getAllEquiposEgresos()
  }

  getAllEquiposEgresos() {
    this.almacenService.getAllEgresoEquipos().subscribe((response) => {
      this.articulos = response.getAllEgresoEquipos;
      console.log(this.articulos)

      this.articulos=this.articulos.filter((el:any)=>el.estado==="PROGRAMADO")

      const marca = this.articulos.filter((item: any) => item.equipoInfo && item.equipoInfo.marcaEquipo !== '' && item.equipoInfo.marcaEquipo !== null).map((item: any) => (item.equipoInfo.marcaEquipo))
      const modelo = this.articulos.filter((item: any) => item.equipoInfo && item.equipoInfo.modeloEquipo !== '' && item.equipoInfo.modeloEquipo !== null).map((item: any) => (item.equipoInfo.modeloEquipo))
      const talla = this.articulos.filter((item: any) => item.equipoInfo && item.equipoInfo.tallaEquipo !== '' && item.equipoInfo.tallaEquipo !== null).map((item: any) => (item.equipoInfo.tallaEquipo))
      const categoria = this.articulos.filter((item: any) => item.equipoInfo && item.equipoInfo.categoria !== '' && item.equipoInfo.categoria !== null).map((item: any) => (item.equipoInfo.categoria))

      this.arrayMarcas = [...new Set(marca)]
      this.arrayModelos = [...new Set(modelo)]
      this.arrayTallas = [...new Set(talla)]
      this.arrayCategorias = [...new Set(categoria)]

      this.dataSource=new MatTableDataSource(this.articulos)

      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return data.fileNumber.toLowerCase().includes(filter) ||
        data.equipoInfo.nombreEquipo.toLowerCase().includes(filter) || 
        data.equipoInfo.marcaEquipo.toLowerCase().includes(filter) ||
        data.equipoInfo.categoria.toLowerCase().includes(filter) ||
        data.equipoInfo.codigo.toLowerCase().includes(filter) ||
        data.equipoInfo.modeloEquipo.toLowerCase().includes(filter);
      };

      this.dataSource.paginator=this.paginator

      this.loading=false
      return response;
    });

  }

/*   getAllEquipos() {
    this.almacenService.getAllEquiposInventario().subscribe((response) => {
      this.articulos = response.getAllEquiposInventario;
      console.log(this.articulos)

      this.articulos=this.articulos.filter((el:any)=>el.estado==="EN CAMPO")

      const marca = this.articulos.filter((item: any) => item.marcaEquipo !== '' && item.marcaEquipo !== null).map((item: any) => (item.marcaEquipo))
      const modelo = this.articulos.filter((item: any) => item.modeloEquipo !== '' && item.modeloEquipo !== null).map((item: any) => (item.modeloEquipo))
      const talla = this.articulos.filter((item: any) => item.tallaEquipo !== '' && item.tallaEquipo !== null).map((item: any) => (item.tallaEquipo))
      const categoria = this.articulos.filter((item: any) => item.categoria !== '' && item.categoria !== null).map((item: any) => (item.categoria))

      this.arrayMarcas = [...new Set(marca)]
      this.arrayModelos = [...new Set(modelo)]
      this.arrayTallas = [...new Set(talla)]
      this.arrayCategorias = [...new Set(categoria)]

      this.dataSource=new MatTableDataSource(this.articulos)
      this.dataSource.paginator=this.paginator

      this.loading=false
      return response;
    });

  } */

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  openDialogModify(element:any) {
    let dialogConfig = new MatDialogConfig();
    this.almacenService.getEquipoInventario(element.equipoInventarioId).subscribe((response) => {
      this.equipo = response.getEquipoInventario;

      console.log(this.equipo)
      dialogConfig.data = {
        idEgreso:element.id,
        id:this.equipo.id,
        nombre: this.equipo.nombreEquipo,
        marca: this.equipo.marcaEquipo,
        modelo: this.equipo.modeloEquipo,
        talla: this.equipo.tallaEquipo,
        categoria: this.equipo.categoria,
        valoracion: this.equipo.valoracionEquipo,
        costo: this.equipo.costo,
        observaciones: this.equipo.observacionEquipo,
        title: "Modificar Equipo",
        estado:3,
        fileNumber:element.fileNumber
      };
      dialogConfig.width = "50%";

      let dialogRef = this.dialog.open(DialogIngresoEquipoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe((result:any) => {
        console.log(result);
        if(result==1){
          this.getAllEquiposEgresos();
        }
      });
    });

  }

  applyFilterSelect() {

    let dataNew: any = this.articulos

    if (this.selectMarca) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo?.marcaEquipo === this.selectMarca)

    } if (this.selectModelo) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo?.modeloEquipo === this.selectModelo)

    } if (this.selectTalla) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo?.tallaEquipo === this.selectTalla)

    } if (this.selectCategoria) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo?.categoria === this.selectCategoria)

    }

    this.dataSource.data = dataNew

  }
}
